module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-321.c420b4d.woff2";